import { render, staticRenderFns } from "./PageClubInvoiceTransfer.vue?vue&type=template&id=cbc88e64&scoped=true&"
import script from "./PageClubInvoiceTransfer.vue?vue&type=script&lang=js&"
export * from "./PageClubInvoiceTransfer.vue?vue&type=script&lang=js&"
import style0 from "./PageClubInvoiceTransfer.vue?vue&type=style&index=0&id=cbc88e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc88e64",
  null
  
)

export default component.exports